// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l1Xm","top":"styles_top__13FjS"};